module.exports = __webpack_public_path__ + "static/media/Ex1-S1.69fc8ffc.PNG";